export default __webpack_public_path__ + "static/media/d1.080953d7.jpg";